// comment-menu.component.tsx
import { Edit, Trash2, Flag } from 'lucide-react';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ReportCommentDialog } from './report-comment';
import { EditCommentDialog } from './edit-comment-dialog';

interface ICommentMenuProps {
  commentId: string;
  userId: string;
  commentOwnerId: string;
  onDelete: (id: string) => void;
  onUpdate: (id: string, content: string) => void;
  commentType: number;
  content: string;
  updateComment: (commentId: string, newContent: string) => void;
  deleteComment: (commentId: string, commentType: number) => Promise<boolean>;
}

const CommentMenu = ({
  commentId,
  userId,
  commentOwnerId,
  onDelete,
  onUpdate,
  commentType,
  content,
  updateComment,
  deleteComment,
}: ICommentMenuProps) => {
  const [isShowMoreMenu, setShowMoreMenu] = useState<boolean>(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleEditComment = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsEditModalOpen(true);
    setShowMoreMenu(false);
  };

  const handleDeleteComment = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isDeleting) return;

    try {
      setIsDeleting(true);
      await deleteComment(commentId, commentType);
      toast.success('Đã xóa bình luận');
    } catch (error) {
      toast.error('Không thể xóa bình luận');
    } finally {
      setIsDeleting(false);
      setShowMoreMenu(false);
    }
  };

  const isOwner = userId === commentOwnerId;

  return (
    <div className="relative flex items-start">
      <button
        className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
        onClick={(e) => {
          e.stopPropagation();
          setShowMoreMenu(!isShowMoreMenu);
        }}
      >
        <HiOutlineDotsVertical size={16} />
      </button>

      {isShowMoreMenu && (
        <div className="absolute right-0 top-full w-48 bg-white rounded-md shadow-lg z-50 dark:bg-gray-800">
          <div>
            {isOwner && (
              <>
                <button
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700"
                  onClick={handleEditComment}
                >
                  Chỉnh sửa
                </button>
                <button
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 dark:text-red-400 dark:hover:bg-gray-700"
                  onClick={handleDeleteComment}
                  disabled={isDeleting}
                >
                  {isDeleting ? 'Đang xóa...' : 'Xóa bình luận'}
                </button>
              </>
            )}
            {userId !== commentOwnerId && (
              <ReportCommentDialog commentId={commentId} commentType={commentType} commentOwnerId={commentOwnerId} />
            )}
          </div>
        </div>
      )}

      <EditCommentDialog
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        commentId={commentId}
        commentType={commentType}
        initialContent={content}
        onUpdate={(id, newContent) => {
          if (typeof updateComment === 'function') {
            updateComment(id, newContent);
          }
          setIsEditModalOpen(false);
        }}
      />
    </div>
  );
};

export default CommentMenu;
